import Main from '@/components/main'
import parentView from '@/components/parent-view'

/**
 * iview-admin中meta除了原生参数外可配置的参数:
 * meta: {
 *  hideInMenu: (false) 设为true后在左侧菜单不会显示该页面选项
 *  notCache: (false) 设为true后页面不会缓存
 *  access: (null) 可访问该页面的权限数组，当前路由设置的权限会影响子路由
 *  icon: (-) 该页面在左侧菜单、面包屑和标签导航处显示的图标，如果是自定义图标，需要在图标名称前加下划线'_'
 *  beforeCloseName: (-) 设置该字段，则在关闭当前tab页时会去'@/router/before-close.js'里寻找该字段名对应的方法，作为关闭前的钩子函数
 * }
 */

export const routerMap = [

    {
        path: '/scinfo',
        name: 'scinfo',
        meta: {
            icon: 'ios-cube',
            title: '市场管理'
        },
        component: Main,
        children: [
          {
                path: 'sc_market',
                name: 'sc_market',
                meta: {
                    icon: 'ios-cube',
                    title: '市场信息管理'
                },
                component: () =>
                    import ('@/view/scinfo/sc_market.vue')
            },
            {
                path: 'scinfo_jobfair',
                name: 'scinfo_jobfair',
                meta: {
                    icon: 'ios-cube',
                    title: '招聘会管理'
                },
                component: () =>
                    import ('@/view/scinfo/jobfair.vue')
            },
          {
                path: 'scinfo_room',
                name: 'scinfo_room',
                meta: {
                    icon: 'ios-cube',
                    title: '面试室管理'
                },
                component: () =>
                    import ('@/view/scinfo/room.vue')
            }



        ]
    },

  {
    path: '/company',
    name: 'company',
    meta: {
      icon: 'ios-cube',
      title: '企业管理'
    },
    component: Main,
    children: [
      {
        path: 'company_info',
        name: 'company_info',
        meta: {
          icon: 'ios-cube',
          title: '企业信息管理'
        },
        component: () =>
          import ('@/view/company/info.vue')
      },
            {
        path: 'company_job',
        name: 'company_job',
        meta: {
          icon: 'ios-cube',
          title: '职位管理'
        },
        component: () =>
          import ('@/view/company/job.vue')
      }
    ]
  },
  {
    path: '/person',
    name: 'person',
    meta: {
      icon: 'ios-cube',
      title: '求职者管理'
    },
    component: Main,
    children: [
      {
        path: 'person_info',
        name: 'person_info',
        meta: {
          icon: 'ios-cube',
          title: '求职者信息管理'
        },
        component: () =>
          import ('@/view/person/info.vue')
      },
      {
        path: 'person_tocompany',
        name: 'person_tocompany',
        meta: {
          icon: 'ios-cube',
          title: '求职管理'
        },
        component: () =>
          import ('@/view/person/tocompany.vue')
      }

    ]
  },
{
    path: '/dispatch',
    name: 'dispatch',
    meta: {
      icon: 'ios-cube',
      title: '劳务派遣用工登记'
    },
    component: Main,
    children: [
      {
        path: 'dispatch_info',
        name: 'dispatch_info',
        meta: {
          icon: 'ios-cube',
          title: '派遣机构管理'
        },
        component: () =>
          import ('@/view/dispatch/dispatch_info.vue')
      },
      {
        path: 'dispatch_person',
        name: 'dispatch_person',
        meta: {
          icon: 'ios-cube',
          title: '用工管理'
        },
        component: () =>
          import ('@/view/dispatch/dispatch_person.vue')
      },
      {
        path: 'dispatch_all',
        name: 'dispatch_all',
        meta: {
          icon: 'ios-cube',
          title: '用工情况查询'
        },
        component: () =>
          import ('@/view/dispatch/dispatch_all.vue')
      }
    ]
  },

  {
    path: '/company_other',
    name: 'company_other',
    meta: {
      icon: 'ios-cloud-upload',
      title: '企业服务'
    },
    component: Main,
    children: [
      // {
      //   path: 'tcrc_zm',
      //   name: 'tcrc_zm',
      //   meta: {
      //     icon: 'ios-cube',
      //     title: '芝麻背调'
      //   },
      //   component: () =>
      //     import ('@/view/person/tcrc_zm.vue')
      // },
      {
        path: 'js_zhy',
        name: 'js_zhy',
        meta: {
          icon: 'ios-cube',
          title: '江苏省智慧就业云平台'
        },
        component: () =>
          import ('@/view/jss/zhy.vue')
      }
    ]
  },
  {
    path: '/account',
    name: 'account',
    meta: {
      icon: 'ios-cloud-upload',
      title: '信息管理'
    },
    component: Main,
    children: [
      {
        path: 'account_company_info',
        name: 'account_company_info',
        meta: {
          icon: 'ios-cog',
          title: '基础信息管理'
        },
        component: () =>
          import ('@/view/account/company_info.vue')
      }
    ]
  },
  {
    path: '/apply',
    name: 'apply',
    meta: {
      icon: 'ios-cloud-upload',
      title: '招聘管理'
    },
    component: Main,
    children: [
      {
        path: 'apply_jobfair',
        name: 'apply_jobfair',
        meta: {
          icon: 'ios-cog',
          title: '招聘会'
        },
        component: () =>
          import ('@/view/apply/jobfair.vue')
      },
      {
        path: 'apply_online',
        name: 'apply_online',
        meta: {
          icon: 'ios-cog',
          title: '在线面试',
          hideInMenu: true
        },
        component: () =>
          import ('@/view/apply/online.vue')
      },
      {
        path: 'apply_job',
        name: 'apply_job',
        meta: {
          icon: 'ios-cog',
          title: '职位管理'
        },
        component: () =>
          import ('@/view/apply/job.vue')
      },
      {
        path: 'apply_application',
        name: 'apply_application',
        meta: {
          icon: 'ios-cog',
          title: '应聘管理'
        },
        component: () =>
          import ('@/view/apply/application.vue')
      }
    ]
  },
  {
    path: '/special_area',
    name: 'special_area',
    meta: {
      icon: 'ios-cloud-upload',
      title: '专区管理'
    },
    component: Main,
    children: [
      {
        path: 'soldier_job',
        name: 'soldier_job',
        meta: {
          icon: 'ios-cog',
          title: '退役军人_职位'
        },
        component: () =>
          import ('@/view/soldier/job.vue')
      },
      {
        path: 'soldier_person',
        name: 'soldier_person',
        meta: {
          icon: 'ios-cog',
          title: '退役军人_个人'
        },
        component: () =>
          import ('@/view/soldier/person.vue')
      },
      {
        path: 'soldier_person_tocompany',
        name: 'soldier_person_tocompany',
        meta: {
          icon: 'ios-cog',
          title: '退役军人_求职'
        },
        component: () =>
          import ('@/view/soldier/tocompany.vue')
      },
      {
        path: 'soldier_jobfair',
        name: 'soldier_jobfair',
        meta: {
          icon: 'ios-cog',
          title: '退役军人_招聘会'
        },
        component: () =>
          import ('@/view/soldier/jobfair.vue')
      },
      {
        path: 'cripple_job',
        name: 'cripple_job',
        meta: {
          icon: 'ios-cog',
          title: '残疾人_职位'
        },
        component: () =>
          import ('@/view/cripple/job.vue')
      },
      {
        path: 'cripple_person',
        name: 'cripple_person',
        meta: {
          icon: 'ios-cog',
          title: '残疾人_个人'
        },
        component: () =>
          import ('@/view/cripple/person.vue')
      },
      {
        path: 'cripple_person_tocompany',
        name: 'cripple_person_tocompany',
        meta: {
          icon: 'ios-cog',
          title: '残疾人_求职'
        },
        component: () =>
          import ('@/view/cripple/tocompany.vue')
      },
      {
        path: 'cripple_jobfair',
        name: 'cripple_jobfair',
        meta: {
          icon: 'ios-cog',
          title: '残疾人_招聘会'
        },
        component: () =>
          import ('@/view/cripple/jobfair.vue')
      }
    ]
  },
  {
    path: '/report',
    name: 'report',
    meta: {
      icon: 'ios-cloud-upload',
      title: '报表管理'
    },
    component: Main,
    children: [
      {
        path: 'report_company',
        name: 'report_company',
        meta: {
          icon: 'ios-cog',
          title: '单位信息汇总表'
        },
        component: () =>
          import ('@/view/report/company.vue')
      },
      {
        path: 'report_job',
        name: 'report_job',
        meta: {
          icon: 'ios-pie',
          title: '职位信息汇总表'
        },
        component: () =>
          import ('@/view/report/job.vue')
      },
      {
        path: 'report_jobfair',
        name: 'report_jobfair',
        meta: {
          icon: 'ios-pie',
          title: '市场信息统计表'
        },
        component: () =>
          import ('@/view/report/jobfair.vue')
      },
      {
        path: 'report_statistics',
        name: 'report_statistics',
        meta: {
          icon: 'ios-pie',
          title: '市场汇总统计表'
        },
        component: () =>
          import ('@/view/report/jobfair_statistics.vue')
      },
      {
        path: 'report_jobfair_signin',
        name: 'report_jobfair_signin',
        meta: {
          icon: 'ios-pie',
          title: '市场签到表'
        },
        component: () =>
          import ('@/view/report/jobfair_signin.vue')
      },
      {
        path: 'report_supply_mon',
        name: 'report_supply_mon',
        meta: {
          icon: 'ios-pie',
          title: '月度供求统计表'
        },
        component: () =>
          import ('@/view/report/jobfair_supply_mon.vue')
      },
      {
        path: 'report_place',
        name: 'report_place',
        meta: {
          icon: 'ios-pie',
          title: '安置就业'
        },
        component: () =>
          import ('@/view/report/jobfair_place.vue')
      },
    ]
  },

  {
    path: '/usermanage',
    name: 'usermanage',
    meta: {
      icon: 'md-contacts',
      title: '用户管理'
    },
    component: Main,
    children: [{
      path: 'user',
      name: 'user',
      meta: {
        icon: 'ios-people',
        title: '用户列表'
      },
      component: () =>
        import ('@/view/user-manage/user.vue')
    },

      {
        path: 'menus',
        name: 'menus',
        meta: {
          icon: 'ios-menu',
          title: '菜单组件'
        },
        component: () =>
          import ('@/view/user-manage/routescomponents.vue')
      },
      {
        path: 'role',
        name: 'role',
        meta: {
          icon: 'ios-person',
          title: '角色管理'
        },
        component: () =>
          import ('@/view/user-manage/role.vue')
      }
    ]
  },
  {
    path: '/activity',
    name: 'activity',
    meta: {
      icon: 'ios-book-outline',
      title: '活动'
    },
    component: Main,
    children: [{
      path: 'voteshow',
      name: 'voteshow',
      meta: {
        icon: 'ios-book-outline',
        title: '投票'
      },
      component: () =>
        import ('@/view/activity/voteshow_1.vue')
    }
    ]
  },
  {
    path: '/hr_bussiness',
    name: 'hr_bussiness',
    meta: {
      icon: 'ios-book-outline',
      title: '人力资源'
    },
    component: Main,
    children: [{
      path: 'hr_bussiness_info',
      name: 'hr_bussiness_info',
      meta: {
        icon: 'ios-book-outline',
        title: '求职跟踪服务'
      },
      component: () =>
        import ('@/view/hr/hr_business_info.vue')
    },{
      path: 'hr_bussiness_config',
      name: 'hr_bussiness_config',
      meta: {
        icon: 'ios-book-outline',
        title: '业务设置'
      },
      component: () =>
        import ('@/view/hr/hr_bussiness_config.vue')
    },

    ]
  },
  {
    path: '/assist',
    name: 'assist',
    meta: {
      icon: 'ios-book-outline',
      title: '援助人员管理'
    },
    component: Main,
    children: [{
      path: 'assist_person',
      name: 'assist_person',
      meta: {
        icon: 'ios-book-outline',
        title: '援助人员信息管理'
      },
      component: () =>
        import ('@/view/assist/assist_person.vue')
    },
      {
        path: 'assist_out',
        name: 'assist_out',
        meta: {
          icon: 'ios-book-outline',
          title: '援助情况反馈'
        },
        component: () =>
          import ('@/view/report/assist_out.vue')
      }
    ,{
      path: 'assist_parameter',
      name: 'assist_parameter',
      meta: {
        icon: 'ios-book-outline',
        title: '参数管理'
      },
      component: () =>
        import ('@/view/sys/assist_parameter.vue')
    }]},
      {
        path: '/assist_s',
        name: 'assist_s',
        meta: {
          icon: 'ios-book-outline',
          title: '援助服务'
        },
        component: Main,
        children: [{
          path: 'assist_server',
          name: 'assist_server',
          meta: {
            icon: 'ios-book-outline',
            title: '援助服务'
          },
          component: () =>
            import ('@/view/assist/assist_server.vue')
        },{
          path: 'assist_kpi',
          name: 'assist_kpi',
          meta: {
            icon: 'ios-book-outline',
            title: '援助服务再分配'
          },
          component: () =>
            import ('@/view/assist/assist_kpi.vue')
        }
    ]
  },
  {
    path: '/ljtc',
    name: 'ljtc',
    meta: {
      icon: 'ios-book-outline',
      title: '乐就小程序'
    },
    component: Main,
    children: [{
      path: 'school_jobfair',
      name: 'school_jobfair',
      meta: {
        icon: 'ios-book-outline',
        title: '高校网络招聘会'
      },
      component: () =>
        import ('@/view/jobfair/jobfair_online.vue')
    },
      {
        path: 'personnelapplyconfig',
        name: 'personnelapplyconfig',
        meta: {
          icon: 'ios-book-outline',
          title: '预约设置'
        },
        component: () =>
          import ('@/view/personnel/applyconfig.vue')
      }
    ]
  },
  {
    path: '/personnel',
    name: 'personnel',
    meta: {
      icon: 'ios-book-outline',
      title: '人才编码'
    },
    component: Main,
    children: [{
      path: 'personnelapply',
      name: 'personnelapply',
      meta: {
        icon: 'ios-book-outline',
        title: '预约记录'
      },
      component: () =>
        import ('@/view/personnel/applylist.vue')
    },
      {
        path: 'personnelapplyconfig',
        name: 'personnelapplyconfig',
        meta: {
          icon: 'ios-book-outline',
          title: '预约设置'
        },
        component: () =>
          import ('@/view/personnel/applyconfig.vue')
      }
    ]
  },
  {
    path: '/allopatry',
    name: 'allopatry',
    meta: {
      icon: 'ios-book-outline',
      title: '医疗保障'
    },
    component: Main,
    children: [{
      path: 'allopatryinfo',
      name: 'allopatryinfo',
      meta: {
        icon: 'ios-book-outline',
        title: '居外就医申请'
      },
      component: () =>
        import ('@/view/allopatry/info.vue')
    }
    ]
  }
]

export const routes = [{
        path: '/login',
        name: 'login',
        meta: {
            title: 'Login - 登录',
            icon: 'md-home',
            hideInMenu: true
        },
        component: () =>
            import ('@/view/login/login_w.vue')
    },
  {
    path: '/gzh',
    name: 'gzh',
    meta: {
      title: '办事大厅',
      icon: 'md-home',
      hideInMenu: true
    },
    component: () =>
      import ('@/view/gzh.vue')
  },

  {
    path: '/login_n',
    name: 'login',
    meta: {
      title: 'Login - 登录',
      icon: 'md-home',
      hideInMenu: true
    },
    component: () =>
      import ('@/view/login/login.vue')
  },

  {
    path: '/resume',
    name: 'resume',
    meta: {
      title: '个人简历',
      icon: 'md-home',
      hideInMenu: true
    },
    component: () =>
      import ('@/view/person/resume.vue')
  },

    {
        path: '/',
        name: '_home',
        redirect: '/home',
        component: Main,
        meta: {
            hideInMenu: true,
            notCache: true
        },
        children: [{
            path: '/home',
            name: 'home',
            meta: {
                hideInMenu: true,
                title: '首页',
                notCache: true,
                icon: 'md-home'
            },
            component: () =>
                import ('@/view/single-page/home')
        }]
    },


    {
        path: '/403',
        name: 'error_403',
        meta: {
            hideInMenu: true
        },
        component: () =>
            import ('@/view/error-page/403.vue')
    },
    {
        path: '/500',
        name: 'error_500',
        meta: {
            hideInMenu: true
        },
        component: () =>
            import ('@/view/error-page/500.vue')
    },
    {
        path: '*',
        meta: {
            icon: 'md-home',
            hideInMenu: true
        },
        component: () =>
            import ('@/view/error-page/404.vue')
    }
]
